import { PencilSquareIcon, TagIcon, CubeIcon } from "@heroicons/react/24/outline";
import ProductStatusBadge from "./ProductStatusBadge";

export default function ProductSummaryCard({ type = "tag", title, status, items = [], onEdit }) {
    const Icon = type === "product" ? CubeIcon : TagIcon;

    return (
        <div className="tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-p-5">
        <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
            <div>
            <div className="tw-flex tw-items-center tw-gap-2">
                <span className="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-bg-cyan-50 tw-text-cyan-700">
                <Icon className="tw-h-4 tw-w-4" />
                </span>

                <h2 className="tw-m-0 tw-text-lg tw-font-bold tw-text-slate-950">
                {title}
                </h2>

                {status ? <ProductStatusBadge status={status} /> : null}
            </div>

            {items.length ? (
                <div className="tw-mt-4 tw-grid tw-gap-4 sm:tw-grid-cols-2 md:tw-grid-cols-4">
                {items.map((item) => (
                    <div key={item.label}>
                    <p className="tw-m-0 tw-text-xs tw-text-slate-500">{item.label}</p>
                    <p className="tw-m-0 tw-mt-1 tw-text-sm tw-font-semibold tw-text-slate-950">
                        {item.value || "-"}
                    </p>
                    </div>
                ))}
                </div>
            ) : null}
            </div>

            {onEdit ? (
            <button
                type="button"
                onClick={onEdit}
                className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 tw-transition hover:tw-bg-slate-50"
            >
                <PencilSquareIcon className="tw-h-4 tw-w-4" />
                Editar
            </button>
            ) : null}
        </div>
        </div>
    );
}